import { axiosWithAuth } from '../withAuth'

/**
 * /favorit/tilfoejfavorit
 */
const setFavorite = async (id: string, type: string): Promise<unknown> => {
    const url = `/favorit/tilfoejfavorit`

    return axiosWithAuth.post(url, null, {
        params: {
            'request.favoritId': id,
            'request.favoritType': type,
        },
    })
}

const removeFavorite = async (id: string, type: string): Promise<unknown> => {
    const url = `/favorit/fjernfavorit`

    return axiosWithAuth.delete(url, {
        params: {
            'request.favoritId': id,
            'request.favoritType': type,
        },
    })
}

export { setFavorite, removeFavorite }
